import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { BookOpen, GitBranch, History, Archive } from 'lucide-react'
import { KnowledgeBaseTab } from '@/components/admin/chatbot/KnowledgeBaseTab'
import { DialogueFlowTab } from '@/components/admin/chatbot/DialogueFlowTab'
import { TrainingTab } from '@/components/admin/chatbot/TrainingTab'
import { VersionHistoryTab } from '@/components/admin/chatbot/VersionHistoryTab'

const ChatbotManager = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Chatbot Manager</h1>
        <p className="text-slate-500 mt-2">
          Train your AI assistant, configure flows, and manage versions.
        </p>
      </div>

      <Tabs defaultValue="knowledge" className="w-full">
        <TabsList className="grid w-full grid-cols-4 max-w-[800px]">
          <TabsTrigger value="knowledge" className="flex gap-2">
            <BookOpen className="h-4 w-4" /> Knowledge Base
          </TabsTrigger>
          <TabsTrigger value="dialogue" className="flex gap-2">
            <GitBranch className="h-4 w-4" /> Dialogue Flow
          </TabsTrigger>
          <TabsTrigger value="training" className="flex gap-2">
            <History className="h-4 w-4" /> Train
          </TabsTrigger>
          <TabsTrigger value="versions" className="flex gap-2">
            <Archive className="h-4 w-4" /> Versions
          </TabsTrigger>
        </TabsList>

        <TabsContent value="knowledge" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Knowledge Base</CardTitle>
              <CardDescription>
                Manage regex triggers and keyword responses.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <KnowledgeBaseTab />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="dialogue" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Dialogue Flow</CardTitle>
              <CardDescription>
                Configure the step-by-step diagnostic conversation.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <DialogueFlowTab />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="training" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Unanswered Questions</CardTitle>
              <CardDescription>
                Review unmatched user queries and create new knowledge entries.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <TrainingTab />
            </CardContent>
          </Card>
        </TabsContent>

        <TabsContent value="versions" className="mt-6">
          <Card>
            <CardHeader>
              <CardTitle>Version History</CardTitle>
              <CardDescription>
                Create backups and restore previous configurations.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <VersionHistoryTab />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  )
}

export default ChatbotManager
